import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
  setInModel,
} from '../../../../utils/helpers/model.helper';
import { File } from '../../../files/file.model';

export const ADDITIONAL_IMAGE_SCHEMA = Object.freeze({
    HEIGHT: 0,
    WIDTH: 0,
    FILE: File,
  }),
  RECORD = generateSchema(ADDITIONAL_IMAGE_SCHEMA),
  KEYS: any = generateKeys(ADDITIONAL_IMAGE_SCHEMA);

export class AdditionalImage extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    props = props && props.toMap ? props.toMap() : fromJS(props || {});

    super(props);

    const selfModel = setInModel(this, [
      {
        key: KEYS.FILE,
        value: props.get(KEYS.FILE) ? new File(this.file) : null,
      },
    ]);

    return selfModel as AdditionalImage;
  }

  get height(): number {
    return this.get(KEYS.HEIGHT);
  }

  get width(): number {
    return this.get(KEYS.WIDTH);
  }

  get file(): File {
    return this.get(KEYS.FILE);
  }
}
